module.exports = __webpack_public_path__ + "static/media/mmm-vest.889b9044.svg";